import { ResponseMerchFlowApplyFilters } from "@CommonApi/merchandise";
import { PlanogramItem, UnrangedPlanogramItem } from "@CommonTypes/merchflow/pog/item";
import { omniAtom } from "src/utils/atoms";

const prefix = "modals/deleteProduct";

export const pogDeleteProductDataAtom = omniAtom({
  prefix,
  key: "data",
  value: null as {
    item: PlanogramItem | UnrangedPlanogramItem;
    availableStores: ResponseMerchFlowApplyFilters["filter_config"];
  } | null,
});
